import {
    REQUEST_HPP_LINK_REQUEST,
    REQUEST_HPP_LINK_SUCCESS,
    REQUEST_HPP_LINK_FAILURE,
} from '../../constants';

const initialState = {
    loader: false,
};
  
export default (state = initialState, action) => {
  
    //This is to ensure immutability of state
    const newState = {...state};
  
    switch (action.type) {
    case REQUEST_HPP_LINK_REQUEST:
        newState.loader = true;
        return newState;
    case REQUEST_HPP_LINK_SUCCESS:
        newState.loader = false;    
        return newState;
    case REQUEST_HPP_LINK_FAILURE:
        newState.loader = false;
        return newState;
    default:
        return state;
    }
};
  